import { useMemo } from 'react';
import {
  augmentAgent,
  augmentClient,
} from '@/common/hooks/referrals/augmentReferralData';
import type { Referral } from '@/common/hooks/referrals/types';
import { getStatusOfInteractionOnReferral } from '@/views/Referrals/views/ReferralsList/ReferralsList.helpers';
import { useCore } from '$api-clients/hooks';

export function useReferral(id?: string): {
  loading: boolean;
  interaction?: Referral;
} {
  const { data, isLoading: loading } = useCore(
    '/referrals/{referralId}',
    id
      ? {
          params: { path: { referralId: id } },
        }
      : null,
  );

  const interaction: Referral | undefined = useMemo(() => {
    if (!data) return undefined;

    const transactingAgent = augmentAgent(data.transactingAgent);

    return {
      ...data,
      referringAgent: augmentAgent(data.referringAgent),
      transactingAgent,
      client: augmentClient(data.client),
      transactionStatus: getStatusOfInteractionOnReferral({
        interaction: data.latestInteraction ?? { status: null },
        transactingAgent: transactingAgent ?? { isSideAgent: false },
      }),
    };
  }, [data]);

  return {
    interaction,
    loading,
  };
}
